<template>
<PageShell>
  <h1 class="site-h1">Disclaimer</h1>
  <p class="site-lead">The information provided on <strong>GBAppWhats</strong> is for general informational and educational purposes only. While we strive to keep our content accurate and current, we make no guarantees regarding the completeness, reliability, or accuracy of the information published on this website.</p>
  <p>Any action you take based on the information found on this website is entirely at your own risk.</p>

  <h2 class="site-h2">Third-Party Application</h2>
  <p>GB WhatsApp is a third-party modified version of WhatsApp developed by independent developers.</p>
  <p><strong>GBAppWhats is not the developer of GB WhatsApp.</strong> We do not create, modify, or maintain the application. Our website simply provides information, guides, and download resources for users interested in learning more about the app.</p>

  <h2 class="site-h2">No Affiliation with Meta</h2>
  <p>GBAppWhats is an independent website and is <strong>not affiliated with, authorized by, endorsed by, or sponsored by Meta Platforms, Inc. or WhatsApp LLC.</strong></p>
  <p>The names <strong>WhatsApp</strong>, <strong>Meta</strong>, related logos, and trademarks are the property of their respective owners and are used solely for identification and informational purposes.</p>

  <h2 class="site-h2">Download Responsibility</h2>
  <p>Downloading and installing third-party applications involves certain risks.</p>
  <p>Users are responsible for:</p>
  <ul class="site-ul">
    <li>Verifying compatibility with their device.</li>
    <li>Backing up important data before installation.</li>
    <li>Understanding the risks associated with modified applications.</li>
    <li>Complying with local laws and regulations.</li>
  </ul>
  <p>GBAppWhats is not responsible for any loss of data, account restrictions, device issues, or other damages resulting from the use of third-party software.</p>

  <h2 class="site-h2">External Links</h2>
  <p>Our website may contain links to external websites or resources. We do not control these websites and are not responsible for their content, availability, security, or privacy practices.</p>
  <p>Visiting third-party websites is done at your own discretion.</p>

  <h2 class="site-h2">Content Updates</h2>
  <p>We regularly review and update our articles to reflect the latest available information. However, app features, download files, and Android compatibility may change without notice.</p>
  <p>If you find incorrect or outdated information, please contact us so we can review and update the content.</p>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'

export default {
  name: 'Disclaimer',
  components: { PageShell },
}
</script>
